export default "__VITE_ASSET__CHywX7CZ__";